import React from "react";

export default function Loader() {
    return (
        <div className="loader-overlay" style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            background: "rgba(255,255,255,0.7)",
            zIndex: 9999,
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
        }}>
            <div className="fa fa-spinner fa-spin fa-3x" style={{ color: "#3085d6" }}></div>
        </div>
    );
}